export const USER_PASSWORD_CHANGE = "user/password/change";
